

import firebase from "../firebase"
import type { fetchedUser, dansukUser }  from "../types/fetchedUser"
import type { Ref } from 'vue'


// Get users but do not actively listen for updates

export const getAllUsers = async function(usersArray: fetchedUser[], loadingState: Ref<boolean>): Promise<void>{

        loadingState.value = true
        const usersCollection = firebase.firestore().collection("team")
        const querySnapshot = await usersCollection.get()
        querySnapshot.forEach((doc) => {
            usersArray.push({
                id: doc.id,
                userName: doc.data().name.first + " " + doc.data().name.last,
                emailAddress: doc.data().emailAddress || "",
                profileImage: doc.data().profileImage || ""
            })
        })
        loadingState.value = false
    }

// Get all users and actively listen for updates

export const getAllUsersReactive = function(usersArray: fetchedUser[], loadingState: Ref<boolean>): () => void{
        const usersCollection = firebase.firestore().collection("team")

        const unsubscribe = usersCollection.onSnapshot((querySnapshot) => {
            querySnapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
                usersArray.push({
                    id: change.doc.id,
                    userName: change.doc.data().name.first + " " + change.doc.data().name.last,
                    emailAddress: change.doc.data().emailAddress || "",
                    profileImage: change.doc.data().profileImage || ""
                })
            }
            if (change.type === "modified") {
                const index = usersArray.findIndex(user => user.id === change.doc.id)
                if (index !== -1) {
                    usersArray[index] = {
                        id: change.doc.id,
                        userName: change.doc.data().name.first + " " + change.doc.data().name.last,
                        emailAddress: change.doc.data().emailAddress || "",
                        profileImage: change.doc.data().profileImage || ""
                        }
                    }
                }
            })
        })

        // Returning unsubscribe function so that it can be called when component is unmounted

        return unsubscribe
    }

// Get single user

export const getSingleUser = async function (userId: string, user: fetchedUser, loadingState: Ref<boolean>): Promise<void>{
    loadingState.value = true

    const userRef = firebase.firestore().collection("team").doc(userId)
    
    await userRef.get().then((userDoc) => {
        const userData = userDoc.data()
        if (userData) {
            user.userName = userData["name"].first + " " + userData["name"].last
            user.emailAddress = userData["emailAddress"] || ""
            user.profileImage = userData["profileImage"] || ""
        }
    }).then(() => {
        loadingState.value = false
    })

}

